export const A11Y_ALERT_ROLE = 'alert';
